import { useEffect, useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	Divider,
	Menu,
	MenuItem,
	Tooltip,
	Typography,
} from "@mui/material";
import { DetailHeader } from "@/controls/detail-panel/DetailPanel";
import { FooterModalButtons } from "@/controls/buttons/FooterModalButtons";
import type { RollsetStatusChange } from "../models/Rollshop";

interface Props {
	targets: RollsetStatusChange[];
	disabled: boolean;
	disabledReason?: string;
	isSaving: boolean;
	onConfirm: (statusCode: string) => void;
	/** True while the menu or the confirmation is open. */
	onOpenChange?: (open: boolean) => void;
}

export const SetOpStatusButton = ({
	targets,
	disabled,
	disabledReason,
	isSaving,
	onConfirm,
	onOpenChange,
}: Props) => {
	const [anchor, setAnchor] = useState<HTMLElement | null>(null);
	const [target, setTarget] = useState<RollsetStatusChange | null>(null);
	const isOpen = anchor !== null || target !== null;

	useEffect(() => {
		onOpenChange?.(isOpen);
	}, [isOpen, onOpenChange]);

	return (
		<>
			<Tooltip title={disabled ? (disabledReason ?? "") : ""}>
				<span>
					<Button
						size="small"
						variant="contained"
						color="success"
						endIcon={<ArrowDropDownIcon />}
						disabled={disabled || isSaving}
						onClick={(e) => setAnchor(e.currentTarget)}
					>
						Set Op. Status as
					</Button>
				</span>
			</Tooltip>
			<Menu
				anchorEl={anchor}
				open={anchor !== null}
				onClose={() => setAnchor(null)}
			>
				{targets.map((t) => (
					<MenuItem
						key={t.ToCode}
						onClick={() => {
							setAnchor(null);
							setTarget(t);
						}}
					>
						{t.ToName}
					</MenuItem>
				))}
			</Menu>
			<Dialog
				open={target !== null}
				onClose={() => setTarget(null)}
				maxWidth="xs"
				fullWidth
			>
				<DetailHeader title="Set Op. Status" onClose={() => setTarget(null)} />
				<form
					onSubmit={(e) => {
						e.preventDefault();
						if (target) onConfirm(target.ToCode);
						setTarget(null);
					}}
				>
					<DialogContent sx={{ py: 2, px: "27px" }}>
						<Typography>
							{`Op. Status will change to '${target?.ToName ?? ""}'. Do you want to continue?`}
						</Typography>
					</DialogContent>
					<Divider />
					<DialogActions sx={{ px: 2, py: 1.5 }}>
						<FooterModalButtons
							onHide={() => setTarget(null)}
							buttonLabel="Confirm"
						/>
					</DialogActions>
				</form>
			</Dialog>
		</>
	);
};
